import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../routes';
import { ApplicationState } from '../../../../store';
import { EConstructionsRoutes } from '../../contractsAndConstructions.routes';
import { Subtitle, Container } from './styles';
import FabricationContractsSelect from '../../../../components/FabricationContractsSelect';
import {
  closeNewConstructionModal,
  updateConstructionRegistrationSettings
} from '../../../../store/ducks/contracts-and-constructions/actions';
import { INITIAL_CONSTRUCTION_REGISTRATION } from '../../../../store/ducks/contracts-and-constructions/types';
import { IFabricationContract } from '../../../../store/ducks/fabrication-contracts/types';
import { Modal } from '@gerdau/hefesto';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';

interface INewConstructionRedirectProps {
  customerContracts: IFabricationContract[];
  disabled: boolean;
}

const NewConstructionRedirect: React.FC<INewConstructionRedirectProps> = ({
  customerContracts,
  disabled
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const constructionRegistrationState = useSelector(
    (appState: ApplicationState) =>
      appState.contractsAndConstructions.constructionRegistration
  );
  const canShowModalState = useSelector(
    (appState: ApplicationState) => appState.contractsAndConstructions
  );

  const contractsManager = useSelector(
    (state: ApplicationState) =>
      state.contractsAndConstructions.contractsManager
  );

  const [contractNumber, setContractNumber] = useState(
    constructionRegistrationState.contractNumber
  );

  const { screenName, itemDescription } = getTaggingInformationScreen(
    'contracts_and_contructions_home_emitter_filter'
  );

  useEffect(() => {
    canShowModalState.canShowNewConstructionModal &&
      dispatch(
        sendTagging({
          screenName: `${screenName}:ModalCadastrarNovaObra`,
          event: 'page_view',
          page: history.location.pathname
        })
      );
  }, [canShowModalState.canShowNewConstructionModal]);

  const goToConstructionRegistration = () => {
    dispatch(closeNewConstructionModal());
    dispatch(
      updateConstructionRegistrationSettings({
        ...INITIAL_CONSTRUCTION_REGISTRATION,
        contractNumber
      })
    );

    history.push(
      `${ERoutes.CONTRACTS_AND_CONSTRUCTIONS}${EConstructionsRoutes.CONSTRUCTION_REGISTRATION}`
    );
  };

  useEffect(() => {
    if (constructionRegistrationState.contractNumber === '') {
      setContractNumber(constructionRegistrationState.contractNumber);
    }
  }, [constructionRegistrationState.contractNumber]);

  return (
    <Container>
      {canShowModalState.canShowNewConstructionModal && (
        <Modal
          title="Cadastrar nova obra"
          modalSize="sm"
          onClose={() => dispatch(closeNewConstructionModal())}
          buttons={{
            left: {
              name: 'buttonCancel',
              onClick: () => {
                dispatch(
                  sendTagging({
                    screenName: `${screenName}:ModalCadastrarNovaObra`,
                    event: 'click',
                    itemName: 'button:cancelar',
                    itemDescription: `${itemDescription}_modalCadastrarNovaObra_cancelar`,
                    filterInfo: `#codEmr:${
                      contractsManager.selectedCustomerId
                        ? contractsManager.selectedCustomerId
                        : 'not_set'
                    }`,
                    contratoObra: contractNumber ? contractNumber : 'not_set'
                  })
                );
                setContractNumber(constructionRegistrationState.contractNumber);
                dispatch(closeNewConstructionModal());
              },
              children: 'Cancelar'
            },
            right: {
              name: 'buttonStartRegister',
              onClick: () => {
                dispatch(
                  sendTagging({
                    screenName: `${screenName}:ModalCadastrarNovaObra`,
                    event: 'click',
                    itemName: 'button:iniciar_cadastro',
                    itemDescription: `${itemDescription}_modalCadastrarNovaObra_iniciarCadastro`,
                    filterInfo: `#codEmr:${
                      contractsManager.selectedCustomerId
                        ? contractsManager.selectedCustomerId
                        : 'not_set'
                    }`,
                    contratoObra: contractNumber ? contractNumber : 'not_set'
                  })
                );
                goToConstructionRegistration();
              },
              disabled: !contractNumber || disabled,
              children: 'Iniciar cadastro',
              type: 'button'
            }
          }}
        >
          <Subtitle>Selecione um contrato disponível para continuar:</Subtitle>
          <FabricationContractsSelect
            hideLabel
            contracts={customerContracts}
            loading={disabled}
            onChange={(value: string) => setContractNumber(value)}
            contractNumber={contractNumber || undefined}
          />
        </Modal>
      )}
    </Container>
  );
};

export default NewConstructionRedirect;
